import { Route, Routes } from "react-router-dom";

import { Routes as AdminRoutes } from "ui/modules/navigation";

import { DashboardPage } from "../pages/DashboardPage";
import { DashboardRouterCmp } from "./types";

/** Nadzorna ploča je početni ekran administracije — stoji na „/". */
const DashboardRouter: DashboardRouterCmp = () => (
  <Routes>
    <Route path={DashboardPage.route} element={<DashboardPage />} />
  </Routes>
);

DashboardRouter.route = AdminRoutes.ModuleRouter;

export default DashboardRouter;
